import SupplierInfoFields, { supplierDisplayName } from '../Fournisseur/SupplierInfoFields';
import PurchaseDiscount from '../shared/PurchaseDiscount';
import '../Reception/SimpleReception.css';
import { validPurchaseQuantities } from '../../helpers/purchaseQuantities';
import { Field, useFormik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Table } from "reactstrap";
import Swal from "sweetalert2";
import { purchaseActions } from "../../sagas/purchaseSlice";
import { supplierActions } from "../../sagas/supplierSlice";
import { FaArrowLeft, FaBuilding, FaBusinessTime, FaEdit, FaEllipsisH, FaEnvelope, FaFilePdf, FaIdCard, FaList, FaMapMarkerAlt, FaMoneyBillWave, FaPhone, FaPlus, FaUser } from "react-icons/fa";
import Select from "react-select";
import { components } from 'react-select';
import { Spinner } from 'reactstrap';
import { receiptNoteActions } from "../../sagas/receiptNoteSlice";
import { formatPrice } from "../../helpers/utility";
import { reglementsFournisseurActions } from "../../sagas/reglementFournisseurSlice";
import CommandeLine from "./CommandeLine";
import * as Yup from "yup";
import { PURCHASE_FORM_PAGE, PURCHASE_ORDERS_PAGE, PURCHASE_PAGE, RECEPTION_FORM_PAGE } from "../../routes/routeConstants";
import "../shared/DocumentForm.css";

const initForm = {
    numero: '',
    fournisseurId: null,
    numeroCheque: '',
    fournisseurNom: '',
    dateCommande: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
    dateOperation: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
    createdAt: null,
    updatedAt: null,
    lignes: [],
    statut: 'EN_ATTENTE',
    montantTotalHT: 0,
    montantTotalTaxe: 0,
    montantTotalAvantRemise: 0,
    montantRemise: 0,
    montantTotalTTC: 0,
    modeReglement: 'ESPECES',
    addresseLivraison: ''
};

const PurchaseForm = ({ onClose, purchase: purchaseProp }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const purchase = purchaseProp || location.state?.purchase || null;
    const [formState, setForm] = useState(purchase || initForm);
    const dispatch = useDispatch();
    const { company } = useSelector(statut => statut.auth);
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [fournisseur, setFournisseur] = useState({
        nom: '',
        prenom: '',
        cin: '',
        telephone1: '',
        telephone2: '',
        email: '',
        adresse: '',
        ville: 'Casablanca',
        typeFournisseur: 'PARTICULIER',
        codePostal: '',
        plafond: 0,
        entreprise: '', // New field for "Entreprise"
        ice: '',// New field for "ICE",
        active: true,
        solde: 0 // Ce champ sera en lecture seule
    });

    const { newOrderNumber, isLoading } = useSelector(statut => statut.purchases);
    const { receiptNotes, isLoading: receiptNoteLoading } = useSelector(statut => statut.receiptNote);
    const [receiptNoteCount, setReceiptNoteCount] = useState(0);
    const [showReceiptNoteListModal, setShowReceiptNoteListModal] = useState(false);
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const [errors, setErrors] = useState({});
    const [allReceived, setAllReceived] = useState(false);
    const closeForm = () => {
        if (onClose) {
            onClose();
            return;
        }

        navigate('/purchases-module/orders');
    };

    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: null,
        dateTo: null,
        statut: "EN_ATTENTE"
    });

    const villesMaroc = [
        'Casablanca', 'Rabat', 'Khouribga', 'Marrakech', 'Fès', 'Tanger',
        'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan',
        'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'
    ];



    useEffect(() => {
        dispatch(supplierActions.search({
            query: ""
        }));

        dispatch(purchaseActions.fetchNewOrderNumber());

    }, [])

    useEffect(() => {

    }, [suppliers])

    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    useEffect(() => {
        if (purchase) {
            fetchReceiptNotesByPurchaseId(purchase.id);
        }
    }, [purchase, dispatch]);

    useEffect(() => {
        if (purchase && receiptNotes) {
            setReceiptNoteCount(receiptNotes.length);
        }
    }, [receiptNotes]);

    const formik = useFormik({
        initialValues: {
            ...formState,
            montantRemise: Number(formState.montantRemise || 0),
            modeRemise: formState.modeRemise || 'MONTANT',
            valeurRemise: formState.valeurRemise ?? formState.montantRemise ?? 0,
            montantTotalAvantRemise: Number(
                formState.montantTotalAvantRemise ??
                ((Number(formState.montantTotalTTC) || 0) + (Number(formState.montantRemise) || 0))
            ),
            numero: purchase ? formState.numero : newOrderNumber,
            addresseLivraison: purchase ? formState.addresseLivraison : company.address
        },
        enableReinitialize: true,
        validationSchema: Yup.object({ fournisseurId: Yup.number().required('Choisissez un fournisseur.'), lignes: Yup.array().min(1, 'Ajoutez au moins un article.') }),
        onSubmit: (values) => {
            if (!validPurchaseQuantities(values.lignes, "quantiteCommandee")) {
                Swal.fire({ icon: 'warning', text: 'La quantité gratuite doit être comprise entre zéro et la quantité globale, qui doit être positive.' });
                return;
            }
           
            Swal.fire({
                title: 'Confirmer cette commande ?',
                text: 'Vérifiez les articles, les quantités et le total à payer.',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Oui, confirmer la commande',
                denyButtonText: 'Enregistrer pour plus tard',
                cancelButtonText: t('common.cancel'),

            }).then((result) => {
                if (result.isConfirmed) {
                    values.statut = 'VALIDE';
                    values.updatedAt = null;
                    values.createdAt = null;

                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        }
                    };

                    if (purchase) {
                        dispatch(purchaseActions.updatePurchase({ ...payload, id: purchase.id }));
                    } else {
                        dispatch(purchaseActions.createPurchase(payload));
                    }
                } else if (result.isDenied) {
                    values.statut = 'EN_ATTENTE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        }
                    };

                    if (purchase) {
                        dispatch(purchaseActions.updatePurchase({ ...payload, id: purchase.id }));
                    } else {
                        dispatch(purchaseActions.createPurchase(payload));
                    }
                } else {

                }
            });
        }
    });

    const { values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

    // Determine if all ordered quantities have been received
    useEffect(() => {
        if (!values || !values.lignes || values.lignes.length === 0) {
            setAllReceived(false);
            return;
        }

        // Sum received quantities per article from receiptNotes
        const receivedMap = {};
        (receiptNotes || []).forEach(note => {
            (note.lignes || []).forEach(line => {
                const key = line.articleId || line.articleCode || line.articleNom;
                receivedMap[key] = (receivedMap[key] || 0) + (Number(line.quantiteRecue) || 0);
            });
        });

        // Check each ordered line
        const allOk = values.lignes.every(line => {
            const key = line.articleId || line.articleCode || line.articleNom;
            const ordered = Number(line.quantiteCommandee || line.quantite || 0);
            const received = Number(receivedMap[key] || 0);
            return received >= ordered;
        });

        setAllReceived(allOk);
    }, [values.lignes, receiptNotes]);


    const fetchReceiptNotesByPurchaseId = (id) => {
        dispatch(receiptNoteActions.getReceiptNotesByPurchaseId({ id }));
    }

    const handleShowReceiptNoteList = () => {
        setShowReceiptNoteListModal(true);
    };

    const handleCloseReceiptNoteListModal = () => {
        setShowReceiptNoteListModal(false);
    };



    // Add this function to handle opening the receipt note modal
    const handleCreateReception = () => {
        // Populate receipt note form with data from purchase order
        const newReceiptNote = {
            commandeId: values.id,
            fournisseurId: values.fournisseurId,
            fournisseurNom: values.fournisseurNom,
            dateReception: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            dateOperation: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            modeReglement: values.modeReglement,
            lignes: values.lignes.map(line => ({
                articleId: line.articleId,
                articleNom: line.articleNom,
                quantiteCommandee: line.quantiteCommandee,
                quantiteRecue: line.quantiteCommandee,
                quantiteGratuite: line.quantiteGratuite ?? 0,
                stockDisponible: line.stockDisponible,
                prixUnitaireHT: line.prixUnitaireHT,
                prixUnitaireTTC: line.prixUnitaireTTC,
                montantHT: line.montantHT,
                tauxTVA: line.tauxTVA,
                montantTTC: line.montantTTC
            })),
            montantTotalHT: values.montantTotalHT,
            montantTotalAvantRemise: values.montantTotalAvantRemise || values.montantTotalTTC,
            montantRemise: values.montantRemise || 0,
            modeRemise: values.modeRemise,
            valeurRemise: values.valeurRemise,
            montantTotalTTC: values.montantTotalTTC,
            montantTotalTaxe: values.montantTotalTaxe,
            statut: 'EN_ATTENTE',
        };

        dispatch(receiptNoteActions.fetchNewBRNumber());
        navigate(RECEPTION_FORM_PAGE, {
            state: {
                initialValues: newReceiptNote,
                purchaseOrder: values,
                returnTo: PURCHASE_FORM_PAGE,
                returnState: { purchase: values },
            },
        });
    };


    const handleSupplierChange = async (selectedOption) => {
        if (selectedOption?.value === values.fournisseurId) return;
        if (values.lignes.length) {
            const choice = await Swal.fire({ title: 'Changer de fournisseur ?', text: 'Les articles choisis seront retirés de cette commande.', showCancelButton: true, confirmButtonText: 'Changer de fournisseur', cancelButtonText: 'Garder ce fournisseur' });
            if (!choice.isConfirmed) return;
        }
        formik.setFieldValue('lignes', []); // Clear the lignes when the supplier changes
        formik.setFieldValue('fournisseurId', selectedOption?.value || null);
        formik.setFieldValue('fournisseurNom', selectedOption?.label || '');
        formik.setFieldValue('montantTotalTTC', 0);
        formik.setFieldValue('montantTotalHT', 0);
        formik.setFieldValue('montantTotalTaxe', 0);
        formik.setFieldValue('montantTotalAvantRemise', 0);
        formik.setFieldValue('montantRemise', 0);
        formik.setFieldValue('valeurRemise', 0);
    };





    const handleCreateSupplier = () => {
        setShowSupplierModal(true);
    };



    const handleSupplierSubmit = () => {
        const newErrors = {};
        if (!supplierDisplayName(fournisseur).trim()) newErrors.name = 'Indiquez le nom du fournisseur.';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        let payload = {
            data: {
                ...fournisseur,
            },

            onSuccess: () => {
                Swal.fire({
                    icon: 'success',
                    title: 'Succès',
                    text: 'Fournisseur enregistré avec succès!',
                    confirmButtonText: 'OK',
                });

                setFournisseur({
                    nom: '',
                    prenom: '',
                    cin: '',
                    telephone1: '',
                    telephone2: '',
                    typeFournisseur: 'PARTICULIER',
                    email: '',
                    adresse: '',
                    ville: 'Casablanca',
                    codePostal: '',
                    plafond: 0,
                    entreprise: '',
                    ice: '',
                    solde: 0,
                    active: true,
                });

                setShowSupplierModal(false);
                setErrors({});
            },
        };


        dispatch(supplierActions.addSupplier(payload));

    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'EN_ATTENTE':
                return <Badge color="secondary">En attente confirmation</Badge>;
            case 'VALIDE':
                return <Badge color="info">Commandé</Badge>;
            case 'LIVRE':
                return <Badge color="primary">Livré</Badge>;
            case 'ANNULE':
                return <Badge color="danger">Annulé</Badge>;
            default:
                return <Badge color="light">-</Badge>;
        }
    };

    const getReceptionStatusBadge = (status) => {
        switch (status) {
            case 'EN_ATTENTE':
                return <Badge color="secondary">En attente confirmation</Badge>;
            case 'VALIDE':
                return <Badge color="success">Confirmée</Badge>;

            default:
                return <Badge color="light">-</Badge>;
        }
    };


    const handleFournisseurChange = (e) => {
        const { name, value } = e.target;
        setFournisseur((prev) => ({
            ...prev,
            [name]: name === 'active' ? value === 'true' : value, // Convert "true"/"false" to boolean for the active field
        }));
    };

    return (
        <Container fluid className="document-form-page simple-reception py-3">
            {(isLoading || receiptNoteLoading) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                </div>
            )}
            <Form onSubmit={handleSubmit} onAbort={closeForm} className="document-form">
                <Card className="document-form-card">
                    <CardHeader className="document-form-header">
                        <Row className="align-items-center">
                            <Col md="12">
                                <div className="document-form-title-row mb-3">
                                    <div>
                                        <h4 className="mb-1">
                                            {purchase ? `Commande N°: ${values.numero || purchase.numero}` : 'Commander des articles'}
                                        </h4>
                                        <div className="text-muted small">{t('purchase.orders')}</div>
                                    </div>
                                    <div className="document-form-header-actions">
                                        {values.statut && getStatusBadge(values.statut)}
                                        <Button type="button" color="light" className="document-form-return" onClick={closeForm}>
                                            <FaArrowLeft className="me-2" />
                                            {t('common.return')}
                                        </Button>
                                    </div>
                                </div>
                                <div className="receipt-step-title"><span>1</span><h2>À qui passez-vous commande ?</h2></div>
                                <Row className="g-3">
                                    <Col md={6}><FormGroup><Label for="purchase-supplier">Fournisseur</Label>
                                        <Select inputId="purchase-supplier" options={fournisseurOptions} isLoading={suppliersLoading}
                                            placeholder="Choisir le fournisseur…" classNamePrefix="select" isDisabled={values.statut !== 'EN_ATTENTE'}
                                            value={fournisseurOptions.find(option => option.value === values.fournisseurId) || null} onChange={handleSupplierChange}
                                            noOptionsMessage={() => 'Aucun fournisseur trouvé'}
                                            components={{ MenuList: ({ children, ...props }) => <components.MenuList {...props}>{children}<div className="border-top p-2"><Button type="button" color="light" block onClick={handleCreateSupplier}>+ Nouveau fournisseur</Button></div></components.MenuList> }} />
                                        {touched.fournisseurId && formik.errors.fournisseurId && <div className="text-danger mt-1">Choisissez un fournisseur.</div>}
                                    </FormGroup></Col>
                                    <Col md={6}><FormGroup><Label for="purchase-date">Date de commande</Label><Input id="purchase-date" type="date" {...getFieldProps('dateCommande')} disabled={values.statut !== 'EN_ATTENTE'} /></FormGroup></Col>
                                </Row>
                                <details className="receipt-optional"><summary>Autres informations : livraison, paiement…</summary>
                                    <Row className="g-3">
                                        <Col md={6}><Label for="purchase-operation-date">Date comptable</Label><Input id="purchase-operation-date" type="date" {...getFieldProps('dateOperation')} disabled={values.statut !== 'EN_ATTENTE'} /></Col>
                                        <Col md={6}><Label for="purchase-payment">Mode de paiement</Label><Input id="purchase-payment" type="select" {...getFieldProps('modeReglement')} disabled={values.statut !== 'EN_ATTENTE'}>
                                            <option value="ESPECES">Espèces</option><option value="CHEQUE">Chèque</option><option value="VIREMENT">Virement</option><option value="CARTE_BANCAIRE">Carte bancaire</option><option value="TRAITE">Traite</option>
                                        </Input></Col>
                                        {values.modeReglement === 'CHEQUE' && <Col md={6}><Label for="purchase-cheque">Numéro du chèque</Label><Input id="purchase-cheque" {...getFieldProps('numeroCheque')} disabled={values.statut !== 'EN_ATTENTE'} /></Col>}
                                        <Col md={12}><Label for="purchase-address">Adresse de livraison</Label><Input id="purchase-address" type="textarea" {...getFieldProps('addresseLivraison')} disabled={values.statut !== 'EN_ATTENTE'} /></Col>
                                    </Row>
                                </details>
                            </Col>

                        </Row>
                    </CardHeader>
                    <CardBody className="document-form-body">
                        <section className="document-form-section document-form-lines-section">
                            <div className="receipt-step-title"><span>2</span><h2>Quels articles voulez-vous commander ?</h2></div>
                            <CommandeLine formik={formik} disabled={values.statut !== 'EN_ATTENTE'} />
                            {touched.lignes && formik.errors.lignes && <div className="text-danger mt-2">Ajoutez au moins un article.</div>}
                        </section>
                        <section className="document-form-section receipt-checkout">
                            <div className="receipt-step-title"><span>3</span><h2>Vérifiez et enregistrez</h2></div>
                            <PurchaseDiscount formik={formik} disabled={values.statut !== 'EN_ATTENTE'} />
                            <div className="receipt-checkout-total"><div>Total à payer au fournisseur<div className="text-muted">{values.lignes.length} article(s) · taxes comprises</div></div><strong>{formatPrice(values.montantTotalTTC)}</strong></div>
                            <div className="receipt-checkout-actions"><Button type="submit" color="primary" disabled={values.statut !== 'EN_ATTENTE'}>Enregistrer la commande</Button><Button type="button" color="link" onClick={closeForm}>Retour</Button></div>
                        </section>
                    </CardBody>
                </Card>
            </Form>
            <Modal isOpen={showSupplierModal} toggle={() => setShowSupplierModal(false)} size="xl">
                <ModalHeader toggle={() => setShowSupplierModal(false)}>
                    {t('supplier.new')}
                </ModalHeader>
                <ModalBody>
                    <SupplierInfoFields supplier={fournisseur} onChange={setFournisseur} errors={errors} />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSupplierSubmit}>
                        {t('common.save')}
                    </Button>
                    <Button color="secondary" onClick={() => setShowSupplierModal(false)}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showReceiptNoteListModal} toggle={handleCloseReceiptNoteListModal} size="xl">
                <ModalHeader toggle={handleCloseReceiptNoteListModal}>
                    {t('reception.receiptNotes')}
                </ModalHeader>
                <ModalBody>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{t('reception.receiptNumber')}</th>
                                <th>{t('reception.dateReception')}</th>
                                <th>{t('reception.deliveryNoteNb')}</th>
                                <th>{t('reception.statut')}</th>
                                <th className="align-middle text-center">{t('common.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {receiptNotes && receiptNotes.map(note => (
                                <tr key={note.id}>
                                    <td>{note.numero}</td>
                                    <td>{new Date(note.dateReception).toLocaleDateString()}</td>
                                    <td>{note.deliveryNoteNb}</td>
                                    <td>{getReceptionStatusBadge(note.statut)}</td>
                                    <td className="align-middle text-center">
                                        <>
                                            {/* <Button color="secondary" title='Téléchargé PDF' onClick={() => handleGeneratePdf(note)} size="sm" className="me-1 px-2 py-1">
                                                <FaFilePdf size={12} className="mr-2" />
                                            </Button> */}

                                            <Button color="warning" title={allReceived ? t('reception.allReceived') : 'Consulter'} onClick={() => {
                                                navigate(RECEPTION_FORM_PAGE, {
                                                    state: {
                                                        reception: note,
                                                        purchaseOrder: values,
                                                        returnTo: PURCHASE_FORM_PAGE,
                                                        returnState: { purchase: values },
                                                    },
                                                });
                                            }} size="sm" className="px-2 py-1" disabled={allReceived}>
                                                <FaEdit size={12} className="mr-2" />
                                            </Button>
                                        </>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleCloseReceiptNoteListModal}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default PurchaseForm;
